import { render } from "./FarmDashboard.vue?vue&type=template&id=3ac3e48a&scoped=true"
import script from "./FarmDashboard.vue?vue&type=script&lang=js"
export * from "./FarmDashboard.vue?vue&type=script&lang=js"

import "./FarmDashboard.vue?vue&type=style&index=0&id=3ac3e48a&lang=css"
import "./FarmDashboard.vue?vue&type=style&index=1&id=3ac3e48a&scoped=true&lang=css"
import "./FarmDashboard.vue?vue&type=style&index=2&id=3ac3e48a&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac3e48a"]])

export default __exports__